import { uuid } from "../uuid";

export const guestAccountId = uuid;
